module.exports = __webpack_public_path__ + "static/the-broken-ladder-fef0243aa724d8d61618cc5d2116e8d3.jpg";